define('webshopProductsCategoriesClipboardView',[
  'module',
  'marionette',
  'template!webshopProductsCategoriesClipboardView'
], function (
  Module,
  Marionette,
  Tpl
) {
  'use strict';

  /**
   * The copied category, shown as a chip with a "clear" cross.
   */
  Module.exports = Marionette.ItemView.extend({
    template: Tpl,
    className: 'webshop-products-categories-clipboard-view',

    ui: {
      clear: '.clear'
    },

    events: {
      'click @ui.clear': 'onClear'
    },

    modelEvents: {
      'change': 'render'
    },

    onRender: function () {
      if (this.model.get('id') !== '') {
        this.$el.attr('title', this.model.get('name') || this.model.get('code'));
        this.$el.css('display', 'flex');
      } else
        this.$el.hide();
    },

    onClear: function (e) {
      e.stopPropagation();
      this.model.set({id: '', code: '', name: ''});
    }
  });
});

